import { render } from "./AddressFile.vue?vue&type=template&id=5bfc8aea&scoped=true"
import script from "./AddressFile.vue?vue&type=script&lang=ts"
export * from "./AddressFile.vue?vue&type=script&lang=ts"

import "./AddressFile.vue?vue&type=style&index=0&id=5bfc8aea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bfc8aea"

export default script